module.exports = __webpack_public_path__ + "static/media/logo-belagua.8d1eb139.png";